import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import {JSONPath} from 'jsonpath-plus';
import * as moment from 'moment/moment';
import handlebars from 'handlebars';

pdfMake.addVirtualFileSystem(pdfFonts);

export class DataTablesExportFiles {
  dataTable: any;

  constructor( dataTable ) {
    this.dataTable = dataTable;
  }

  tableWidths() {
    const compDefinition = this.dataTable.componentDefinition;
    const visibleColExport = (typeof compDefinition.exportSettings !== 'undefined'
      && typeof compDefinition.exportSettings.exportVisibleOnly !== 'undefined' )
      ? compDefinition.exportSettings.exportVisibleOnly : false;

    const totalTableWidth = compDefinition.gridColumns.reduce( (sum, item) => {
      let num = 1;

      if( !visibleColExport ){
        num = item.width ?? 1;
      }else{
        if( item.visible !== false ){
          num = item.width
        }
      }

      return sum + num;
    }, 0);

    const tableWidths = compDefinition.gridColumns.map( item => {
      const width = item.width ?? 1;
      if(!visibleColExport){
        return ((width / totalTableWidth) * 100) + '%';
      }

      if( item.visible !== false ){
        return ((width / totalTableWidth) * 100) + '%';
      }
    })

    return tableWidths.filter(n => n);
  }

  exportCsv( rows: any, headers: any, format: any, contextParams: any ){
    const query = {
      urlExportMode: 'excelFormat',
      stripHTML: this.dataTable.componentDefinition?.exportSettings?.stripHTML ?? false
    };

    const processRow = (row) => {
      const finalVal = [];
      for( const header of headers){

        const matches = JSONPath({path: header.field, json: row});
        const innerValue = matches.length > 0 ? matches[0] : null;

        const value = this.exportFormatCell(row, header, innerValue, query, contextParams);
        let result = value;

        if(typeof value === 'string' || typeof value === 'object'){
            // result = typeof value === 'string' ? value.replace(/"/g, '""') :
            // value?.title.replace(/"/g, '""');

          if (typeof value === 'string') {
            result = value.replace(/"/g, '""');
          } else if (typeof value === 'object' && value?.title) {
            result = value.title.replace(/"/g, '""');
          }

          if (result && result.search(/([",\n])/g) >= 0)
            result = '"' + result + '"';
        }
        finalVal.push(result);
      }
      return finalVal.join(',') + '\n';
    };

    const processHeader = () => {
      const finalVal = [];
      for( const header of headers){
        const innerValue = header.title;
        let result = innerValue.replace(/"/g, '""');
        if (result.search(/([",\n])/g) >= 0)
          result = '"' + result + '"';
        finalVal.push(result);
      }
      return finalVal.join(',') + '\n';
    };

    let csvFile = '';

    csvFile += processHeader();

    for(const row of rows){
      csvFile += processRow(row);
    }


    const blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });

    const link = document.createElement('a');
    if (link.download !== undefined) { // feature detection
      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', format.fileName);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  exportPdf( rows: any, headers: any, format: any, contextParams: any ){
    const query = {
      urlExportMode: 'pdfFormat',
      stripHTML: this.dataTable.componentDefinition?.exportSettings?.stripHTML ?? false
    };

    const processRow = (row) => {
      const finalRow = [];
      for( const header of headers){

        const matches = JSONPath({path: header.field, json: row});
        const initValue = matches.length > 0 ? matches[0] : null;
        const value = this.exportFormatCell(row, header, initValue, query, contextParams);
        finalRow.push({
          text: value ?? '',
          border: [false, false, false, true],
          style: 'normalText'
        });
      }
      return finalRow;
    };

    const processHeader = () => {
      const finalRow = [];
      for( const header of headers){
        const result = header.title;
        finalRow.push({
          text: result ?? '',
          border: [false, false, false, { width: 2, color: 'black' }],
          style: 'header'
        });
      }
      return finalRow;
    };

    const table = [processHeader()];

    for(const row of rows){
      table.push(processRow(row));
    }

    const docDefinition = {
      pageSize: format.size,
      pageOrientation: format.layout,
      pageMargins: [format.margin, format.margin, format.margin, format.margin],
      content: [
        {
          table: {
            headerRows: 1,
            widths: this.tableWidths(),
            body: table,
          },

          layout: {
            hLineWidth: (i, node) => {
              if (i === 0 || i === node.table.body.length) {
                return 0;
              }
              return (i === node.table.headerRows) ? 2 : 1;
            },
            vLineWidth: (i, node) => {
              return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
            }
          },
          style: 'normalText'
        },
      ],
      styles: {
        header: { fontSize: format.headerFontSize, bold: true },
        normalText: { fontSize: format.fontSize },
      },
    };
    console.log('docDef', { ...docDefinition});
    console.log('format', format);
    console.log('table', JSON.stringify(table));
    pdfMake.createPdf(docDefinition).download( format.fileName);
  }

  exportFormatCell(row, header, value, query, contextParams) {

    if (header.cellTemplate) {
      const context = {
        row: row,
        result: row,
        ...contextParams
      };
      try {
        const hrefTpl = handlebars.compile(header.cellTemplate);
        return hrefTpl(context);
      } catch (e) {

      }
    }

    if (header.type === 'date' && header.format) {
      value = moment(value).format(header.format);
    }

    if (header.type === 'url') {
      const hrefTpl = handlebars.compile(header.href);
      const url = hrefTpl(row);
      let fullUrl = url;
      const hasDomain = /^https?:\/\/[^\/?]+\/$/g.test(url);
      if( !hasDomain ){
        const port = window.location.port ? `:${window.location.port}` : ``;
        fullUrl = window.location.protocol+ '//' + window.location.hostname + port + url;
      }
      const excelFormat = `=HYPERLINK("${fullUrl}", "${value}")`;
      const exportMode = header.urlExportMode ?? query.urlExportMode ?? 'textOnly';

      switch (exportMode) {
        case 'textOnly':
          return value;
        case 'linkOnly':
          return url;
        case 'excelFormat':
          return excelFormat;
        case 'pdfFormat':
          return {
            text: value ?? '',
            link: fullUrl
          }
        default:
          return {
            title: value ?? '',
            type: header.type,
            href: hrefTpl(row)
          };
      }
    }

    if (header.filter === 'arrayFilter' && header.arrayField) {
      if (value.length) {
        let newValue = '';
        for (const v of value) {
          if (typeof v === 'object') {
            const matches =  JSONPath({path: header.arrayField, json: v});
            if (matches.length > 0) {
              newValue += matches[0];
            }
          } else {
            newValue += v;
          }

          if (value.indexOf(v) < value.length - 1 && !newValue.endsWith(', ')) {
            newValue += ', ';
          }
        }

        value = newValue;
      }
    }

    const stripHTML = (text) => {
      const shouldStripHTML = query.stripHTML === true;
      if (!text || typeof text !== 'string' || !shouldStripHTML) {
        return text;
      }

      text = text.replace(/<[^>]*>?/gm, '');
      return text;
    };

    if( query.stripHTML ){
      value = stripHTML(value);
    }

    return value;
  }
}
